var rules = (function (exports, _models, _tools) {
    'use strict';

    var KineticClient = /** @class */ (function () {
        function KineticClient(e) {
            this.e = e;
        }
        KineticClient.prototype.updateExternalSalesOrder = function (company, custNum, orderNum, poNum, partNum, kbmaxConfiguredProductId, orderHed, orderDtl) {
            return this.e.kineticUpdateSalesOrder({ company: company, custNum: custNum, orderNum: orderNum, poNum: poNum, partNum: partNum, kbmaxConfiguredProductId: kbmaxConfiguredProductId, orderHed: orderHed, orderDtl: orderDtl }).then(function (resp) {
                if (resp.statusCode >= 200 && resp.statusCode < 400) {
                    var body = JSON.parse(resp.body);
                    if (body)
                        body = body.parameters;
                    if (body)
                        body = body.ds;
                    return body;
                }
                throw resp.body;
            });
        };
        KineticClient.prototype.quoteToSalesOrder = function (quote, company, custNum, orderNum, poNum) {
            return this.e.kineticQuoteToSalesOrder({
                quote: quote,
                company: company,
                custNum: custNum,
                orderNum: orderNum,
                poNum: poNum
            }).then(function (resp) {
                if (resp.statusCode >= 200 && resp.statusCode < 400) {
                    var body = JSON.parse(resp.body);
                    if (body)
                        body = body.parameters;
                    if (body)
                        body = body.ds;
                    return body;
                }
                throw resp.body;
            });
        };
        KineticClient.prototype.attach = function (source, filePath, idQuote, idTag, idQuoteProduct, kineticDocumentType) {
            return this.e.attachFileToKinetic({
                source: source,
                filePath: filePath,
                idQuote: idQuote,
                idTag: idTag,
                idQuoteProduct: idQuoteProduct,
                kineticDocumentType: kineticDocumentType
            }).then(function (resp) {
                if (resp.statusCode >= 200 && resp.statusCode < 400) {
                    var body = JSON.parse(resp.body);
                    if (body)
                        body = body.parameters;
                    if (body)
                        body = body.ds;
                    return body;
                }
                throw resp.body;
            });
        };
        KineticClient.prototype.attachMedia = function (mediaPath) {
            return this.e.attachFileToKinetic({
                source: 0,
                filePath: mediaPath
            });
        };
        KineticClient.prototype.attachByTag = function (idQuote, idTag) {
            return this.e.attachFileToKinetic({
                source: 1,
                idQuote: idQuote,
                idTag: idTag
            });
        };
        KineticClient.prototype.attachQuoteProduct = function (idQuote, idTag, idQuoteProduct) {
            return this.e.attachFileToKinetic({
                source: 1,
                idQuote: idQuote,
                idTag: idTag,
                idQuoteProduct: idQuoteProduct
            });
        };
        KineticClient.prototype.apiCall = function (url, method, body, company) {
            return this.e.kineticApiCall({
                url: url,
                method: method,
                body: body,
                company: company
            });
        };
        return KineticClient;
    }());

    // A more performant implementaion of Q promises that is agnostic to async vs. sync
    // functions. In Q, a promise is always performed one frame afterwards, whereas here,
    // if the wrapped function or value is actually synchronous, it will perform synchronously.
    // The side-effect is the exact ordering of operations will be dependent on whether the
    // passed value is synchronous or not. With Q, all operations will always be performed
    // after the promise is created/returned and other synchronous code is executed. Here,
    // synchronous code will be performed BEFORE the sync operations after the promise is
    // created, whereas asynchronous code will be performed AFTER.
    //
    // In other words, any code contained in the promise resolution should NOT assume sync
    // code after promise creation has taken effect.
    var KPromise = /** @class */ (function () {
        function KPromise(value) {
            this.$isKPromise = true;
            this.then = function (onFulfill, onReject) {
                if (value && !value.$isKPromise && typeof value.then === "function") {
                    return value.then(onFulfill, onReject);
                }
                else if (value && value.$isKPromise) {
                    return value.then(onFulfill, onReject);
                }
                else {
                    return new KPromise(onFulfill(value));
                }
            };
            this.catch = function (onReject) {
                var wrapped = value;
                if (wrapped && typeof wrapped.then === "function") {
                    return typeof wrapped.catch === "function"
                        ? wrapped.catch(onReject)
                        : wrapped.then(undefined, onReject);
                }
                return new KPromise(value);
            };
            this.finally = function (onfinally) {
                var wrapped = value;
                if (wrapped && typeof wrapped.then === "function") {
                    if (typeof wrapped.finally === "function")
                        return wrapped.finally(onfinally);
                    return wrapped.then(function (result) {
                        if (onfinally)
                            onfinally();
                        return result;
                    }, function (error) {
                        if (onfinally)
                            onfinally();
                        throw error;
                    });
                }
                if (onfinally)
                    onfinally();
                return new KPromise(value);
            };
        }
        return KPromise;
    }());
    var FluentIf = /** @class */ (function () {
        function FluentIf(promise) {
            this.promise = promise;
        }
        FluentIf.prototype.elseIf = function (condition, _cb) {
            // If there is an existing promise, then it means a prior
            // condition was true, so we ignore this one unconditionally.
            if (!this.promise && condition) {
                this.promise = new KPromise(_cb());
            }
            return this;
        };
        FluentIf.prototype.else = function (_cb) {
            if (!this.promise) {
                this.promise = new KPromise(_cb());
            }
            return this;
        };
        // Callback is called after promise is resolved from
        // whatever condition passed.
        FluentIf.prototype.finally = function (_cb) {
            if (!this.promise) { // if no condition was met
                // need to new up a KbPromise so that the consumer can treat the if block like a promise
                if (_cb)
                    return new KPromise(_cb());
            }
            else { // a condition was met
                return this.promise.then(function (res) {
                    // we assume that if the result of the condition is something other than undefined,
                    // then the return block was hit.  So we just return that value.
                    // we can assume this because our snap return block is set to generate
                    // something like 'return val || null'
                    if (res !== undefined) {
                        return res;
                    }
                    else {
                        if (_cb) {
                            return _cb();
                        }
                    }
                });
            }
        };
        return FluentIf;
    }());
    // Special if implementation which is promise-friendly. Especially useful in
    // snap code where we are sort of simulating "await" functionality. Used in
    // conjunction with KPromise
    function _if(condition, _cb) {
        var promise;
        if (condition)
            promise = new KPromise(_cb());
        return new FluentIf(promise);
    }
    // Special while implementation which is promise-friendly. Note that this function
    // uses recursion, so the while loop is effectively limited to the stack size limit
    // for the browser. Tests have shown that the latest browsers have a limit exceeding
    // 20,000, so these loops are limited to 20,000 iterations or so (not accounting for
    // the base stack overhead, which I imagine should be less than 20 or so).
    //
    // http://stackoverflow.com/questions/17217736/while-loop-with-promises
    //
    // http://stackoverflow.com/questions/7826992/browser-javascript-stack-size-limit
    function _while(condition, _cb) {
        var promise;
        if (condition())
            promise = new KPromise(_cb());
        else
            return new KPromise(null);
        return promise.then(function (_break) {
            if (_break)
                return;
            return _while(condition, _cb);
        });
    }
    // Promise-friendly do-while loop. Uses same recusive plan as _while() above.
    function _dowhile(condition, _cb) {
        var promise = new KPromise(_cb());
        if (!condition()) {
            return promise;
        }
        else {
            return promise.then(function (_break) {
                if (_break)
                    return;
                return _dowhile(condition, _cb);
            });
        }
    }
    // Promise-friendly for loop. Uses same recusive method as _while() above.
    function _for(initial, condition, each, _cb) {
        initial();
        var promise = new KPromise(null);
        if (condition())
            promise = new KPromise(_cb());
        else
            return promise;
        return promise.then(function (_break) {
            if (_break) {
                return;
            }
            each();
            return _for(function () { }, condition, each, _cb);
        });
    }
    /**
     * used by while and for loops in snap to make sure we don't end up with an infinite loop
     */
    var Loop = /** @class */ (function () {
        function Loop(isAsync) {
            if (isAsync === void 0) { isAsync = false; }
            this.isAsync = isAsync;
            this.i = 0;
            this.max = isAsync ? 10000 : 1000000; // we allow far less iterations for async loops
        }
        Loop.prototype.check = function () {
            this.i++;
            if (this.i > this.max) {
                // tslint:disable-next-line:max-line-length
                throw new Error("Infinite loop detected.  A maximum of ".concat(this.max, " iterations is allowed for ").concat(this.isAsync ? "an async" : "a", " loop"));
            }
        };
        return Loop;
    }());

    var OracleCpqClient = /** @class */ (function () {
        function OracleCpqClient(e) {
            this.e = e;
        }
        OracleCpqClient.prototype.createTransaction = function (model) {
            return this.e.callOracleCpq({
                operation: _models.eOracleCpqOperation.createTransaction,
                params: model
            });
        };
        OracleCpqClient.prototype.attachByTag = function (transactionId, documentNumber, variableName, processVarName, idQuote, idTag) {
            return this.e.attachFileToOracle({
                source: 0,
                transactionId: transactionId,
                documentNumber: documentNumber,
                variableName: variableName,
                processVarName: processVarName,
                idQuote: idQuote,
                idTag: idTag
            });
        };
        OracleCpqClient.prototype.attachMedia = function (transactionId, documentNumber, variableName, processVarName, mediaPath) {
            return this.e.attachFileToOracle({
                source: 1,
                transactionId: transactionId,
                documentNumber: documentNumber,
                variableName: variableName,
                processVarName: processVarName,
                filePath: mediaPath
            });
        };
        return OracleCpqClient;
    }());

    /*
        The js in this file is included with every rule that is run (on client and server and clara plugin).
        Only put stuff in here that every rule relies on!
    */
    var _tableDb = {};
    function getTables(e, args) {
        _tableDb = _tableDb || {};
        if (args.ids.every(function (id) { return _tableDb[id] != null; })) {
            return new KPromise(args.ids.map(function (id) { return _tableDb[id]; }));
        }
        else {
            return e.getTables(args).then(function (tables) {
                tables.forEach(function (t, i) {
                    var dateCols = t.columns.filter(function (c) { return (c.type || c["Type"]) == _models.eColumnType.date; });
                    if (dateCols.length) {
                        t.data.forEach(function (row) {
                            dateCols.forEach(function (dateCol) {
                                var dateColName = dateCol.name || dateCol["Name"];
                                row[dateColName] = new Date(row[dateColName]);
                            });
                        });
                    }
                    _tableDb[args.ids[i]] = t.data;
                });
                return tables.map(function (t) { return t.data; });
            });
        }
    }
    function getUploadFieldUrl(e, field) {
        var value = field.value;
        return e.baseUrl + "/api/quotes/filefromconfiguratorfield/" + value.path;
    }
    function clearTableCache() {
        _tableDb = {};
    }
    function r(v) {
        if (v === undefined)
            v = null;
        return v;
    }
    var _globalVariables = {};
    function declareGlobalVariable(variableName, defaultValue) {
        if (typeof (_globalVariables[variableName]) === "undefined") {
            _globalVariables[variableName] = defaultValue;
        }
    }
    function setGlobalVariable(variableName, value) {
        _globalVariables[variableName] = value;
    }
    function getGlobalVariable(variableName) {
        return _globalVariables[variableName];
    }
    function indexOf(haystack, needle) {
        if (!haystack)
            return -1;
        return haystack.indexOf(needle);
    }
    function moveItemInArray(array, item, index) {
        var idx = array.indexOf(item);
        if (idx < 0)
            return;
        array.splice(idx, 1);
        array.splice(index, 0, item);
    }
    function stringLength(str) {
        if (!str)
            return 0;
        return str.length;
    }
    function strReplace(search, replaceWith, subject, useRegex) {
        if (useRegex === void 0) { useRegex = true; }
        if (!search)
            search = "";
        if (!replaceWith)
            replaceWith = "";
        if (!subject)
            subject = "";
        if (useRegex) {
            return subject.replace(new RegExp(search, "gi"), replaceWith);
        }
        else {
            var esc = search.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
            var rgx = new RegExp(esc, 'ig');
            return subject.replace(rgx, replaceWith);
        }
    }
    function translateTemplateLiteral(tmpltStr, obj) {
        // If there are no properties in the object don't bother interpolating  
        if (!obj)
            return tmpltStr;
        var propsArr = Object.getOwnPropertyNames(obj);
        var interpolatedStr = tmpltStr;
        propsArr.forEach(function (propName) {
            interpolatedStr = interpolatedStr.replace(new RegExp("\\${" + propName + "}", "gi"), obj[propName]);
        });
        return interpolatedStr;
    }
    /*
        Strmatches is a simplified version of JS's str.match function. Instead of returning an
        array of matches, it simply returns true/false depending on if a match is found.
    */
    function strMatch(search, subject) {
        if (!search)
            search = "";
        if (!subject)
            subject = "";
        var match = subject.match(search);
        return match != null && match.length > 0;
    }
    function getCharCodeAt(subject, index) {
        if (!subject)
            subject = "";
        return subject.charCodeAt(index);
    }
    function toUpperCase(str) {
        if (!str)
            return "";
        return str.toUpperCase();
    }
    function toLowerCase(str) {
        if (!str)
            return "";
        return str.toLowerCase();
    }
    function capitalize(str) {
        if (!str)
            return "";
        return str.capitalize();
    }
    function toTitleCase(str) {
        if (!str)
            return "";
        return str.toPascalCase();
    }
    function trim(str) {
        if (!str)
            return "";
        return str.trim();
    }
    function objToString(v) {
        if (typeof v == "undefined" || v === null)
            return "";
        return v.toString();
    }
    function stringSubstring(str, start, end) {
        if (!str)
            return "";
        return str.substring(start, end);
    }
    function isNumeric(obj) {
        // Need to check for empty strings and trim the object because isNaN() "incorrectly" returns false for
        // empty strings, whitespace, and arrays.
        return !isNaN(parseFloat(obj)) && isFinite(obj);
    }
    // export function sleep(time: number): Q.IPromise<any> {
    //     let d = Q.defer();
    //     setTimeout(() => {
    //         d.resolve(null);
    //     }, time);
    //     return d.promise;
    // }
    function getQuoteProductFieldValue(quoteProduct, fieldName) {
        var cp = quoteProduct.configuredProduct;
        if (!cp)
            return null;
        var field = cp.fields.find(function (f) { return f.name == fieldName; });
        if (!field)
            return null;
        if (field.stringValue)
            return field.stringValue;
        if (field.numberValue)
            return field.numberValue;
        if (field.objectValue)
            return field.objectValue;
        if (field.dateValue)
            return field.dateValue;
        return field.booleanValue;
    }
    function setQuoteProductFieldValue(args) {
        var cp = args.quoteProduct.configuredProduct;
        if (cp) {
            var field = cp.fields.find(function (f) { return f.name == args.fieldName; });
            if (field) {
                if (field.hasOwnProperty("stringValue")) {
                    field.stringValue = args.value;
                }
                else if (field.hasOwnProperty("numberValue")) {
                    field.numberValue = args.value;
                }
                else if (field.hasOwnProperty("booleanValue")) {
                    field.booleanValue = args.value;
                }
                else if (field.hasOwnProperty("dateValue")) {
                    field.dateValue = args.value;
                }
                else if (field.hasOwnProperty("uploadValue")) {
                    field.uploadValue = args.value;
                }
                else if (field.hasOwnProperty("objectValue")) {
                    field.objectValue = args.value;
                }
            }
        }
    }
    function factorial(value) {
        var result = 1;
        for (var i = 2; i <= value; i++) {
            result = result * i;
        }
        return result;
    }
    function padStringLeft(str, padChars) {
        return padChars.substring(str.toString().length) + str;
    }
    // Returns a new date with the added amount
    function dateAdd(date, units, amount) {
        var newDate = new Date(date.getTime());
        if (units == _tools.eDateUnit.date) {
            newDate.setDate(newDate.getDate() + amount);
        }
        else if (units == _tools.eDateUnit.fullYear) {
            newDate.setFullYear(newDate.getFullYear() + amount);
        }
        else if (units == _tools.eDateUnit.hours) {
            newDate.setHours(newDate.getHours() + amount);
        }
        else if (units == _tools.eDateUnit.minutes) {
            newDate.setMinutes(newDate.getMinutes() + amount);
        }
        else if (units == _tools.eDateUnit.month) {
            newDate.setMonth(newDate.getMonth() + amount);
        }
        else if (units == _tools.eDateUnit.seconds) {
            newDate.setSeconds(newDate.getSeconds() + amount);
        }
        return newDate;
    }
    function formatDate(d, format) {
        // Very simple implementation
        var date;
        if (typeof d == "object") {
            date = d;
        }
        else if (typeof d == "string") {
            date = new Date(Date.parse(d));
        }
        else if (typeof d == "number") {
            date = new Date(d);
        }
        else {
            throw new Error("Date is in invalid format: " + (typeof d));
        }
        if (format == null)
            format = "short";
        var fullMonths = [
            "January",
            "February",
            "March",
            "April",
            "May",
            "June",
            "July",
            "August",
            "September",
            "October",
            "November",
            "December"
        ];
        var fullDays = [
            "Sunday",
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday",
            "Friday",
            "Saturday"
        ];
        var keys = {
            "fullDate": function (date) { return "$EEEE, $MMMM $d, $yyyy"; },
            "longDate": function (date) { return "$MMMM $d, $yyyy"; },
            "mediumDate": function (date) { return "$MMM $d, $yyyy"; },
            "shortDate": function (date) { return "$M/$d/$yy"; },
            "mediumTime": function (date) { return "$h:$mm:$ss $a"; },
            "shortTime": function (date) { return "$h:$mm $a"; },
            "medium": function (date) { return "$MMM $d, $yy $h:$mm:$ss $a"; },
            "short": function (date) { return "$M/$d/$yy $h:$mm $a"; },
            "\\$yyyy": function (date) { return date.getFullYear(); },
            "\\$yy": function (date) { return date.getFullYear() - 2000; },
            "\\$dd": function (date) { return padStringLeft(date.getDate(), "00"); },
            "\\$d": function (date) { return date.getDate(); },
            "\\$HH": function (date) { return padStringLeft(date.getHours(), "00"); },
            "\\$H": function (date) { return date.getHours(); },
            "\\$hh": function (date) { return padStringLeft(date.getHours() ? date.getHours() % 12 : 12, "00"); },
            "\\$h": function (date) { return date.getHours() ? date.getHours() % 12 : 12; },
            "\\$mm": function (date) { return padStringLeft(date.getMinutes(), "00"); },
            "\\$m": function (date) { return date.getMinutes(); },
            "\\$ss": function (date) { return padStringLeft(date.getSeconds(), "00"); },
            "\\$s": function (date) { return date.getSeconds(); },
            "\\$Z": function (date) { return date.getTimezoneOffset(); },
            "\\$a": function (date) { return date.getHours() > 12 ? "PM" : "AM"; },
            "\\$MMMM": function (date) { return fullMonths[date.getMonth() % 12]; },
            "\\$MMM": function (date) { return fullMonths[date.getMonth() % 12].substr(0, 3); },
            "\\$MM": function (date) { return padStringLeft(date.getMonth() + 1, "00"); },
            "\\$M": function (date) { return date.getMonth() + 1; },
            "\\$EEEE": function (date) { return fullDays[date.getDay()]; },
            "\\$EEE": function (date) { return fullDays[date.getDay()].substr(0, 3); }
        };
        for (var key in keys) {
            format = format.replace(new RegExp(key, "g"), keys[key](date));
        }
        return format;
    }
    // http://stackoverflow.com/questions/736513/how-do-i-parse-a-url-into-hostname-and-path-in-javascript
    function getLocation(href) {
        var match = href.match(/^(https?\:)\/\/(([^:\/?#]*)(?:\:([0-9]+))?)(\/[^?#]*)(\?[^#]*|)(#.*|)$/);
        if (match) {
            return {
                protocol: match[1],
                host: match[2],
                hostname: match[3],
                port: match[4],
                pathname: match[5],
                search: match[6],
                hash: match[7]
            };
        }
        return null;
    }
    function getNestedConfigurator(config, e) {
        if (typeof config == "string") {
            return e.kom.getByName(config);
        }
        return config;
    }
    function logout() {
        fetch("/api/auth/logout", {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ doNotReplay: true })
        })
            .then(function () {
            window.location.href = '/';
        })
            .catch(function (err) {
            console.error('Logout failed:', err);
        });
    }
    // http://stackoverflow.com/questions/1714786/querystring-encoding-of-a-javascript-object
    function toQueryString(obj, prefix) {
        var str = [];
        for (var p in obj) {
            if (obj.hasOwnProperty(p)) {
                var k = prefix ? prefix + "[" + p + "]" : p;
                var v = obj[p];
                str.push(typeof v == "object" ?
                    toQueryString(v, k) :
                    encodeURIComponent(k) + "=" + encodeURIComponent(v));
            }
        }
        return str.join("&");
    }
    function roundNumber(num, interval, mode) {
        var roundedNum;
        if (mode == "Math.ceil")
            roundedNum = Math.ceil(num / interval);
        else if (mode == "Math.floor")
            roundedNum = Math.floor(num / interval);
        else
            roundedNum = Math.round(num / interval);
        return parseFloat((interval * roundedNum).toFixed(getPrecision(interval)));
    }
    function getPrecision(num) {
        if (Math.floor(num) === num)
            return 0;
        return num.toString().split(".")[1].length || 0;
    }
    var ClientLogger = /** @class */ (function () {
        function ClientLogger() {
        }
        ClientLogger.prototype.push = function (msg) {
            if (typeof window !== "undefined" && window.console) {
                if (String(msg.type) === 'error') {
                    window.console.error(msg.message);
                }
                else if (String(msg.type) === 'warning') {
                    window.console.warn(msg.message);
                }
                else if (String(msg.type) === 'info') {
                    window.console.info(msg.message);
                }
                else {
                    window.console.log(msg.message);
                }
            }
        };
        return ClientLogger;
    }());
    function btoa(input) {
        if (typeof window !== "undefined" && window.btoa) {
            return window.btoa(input);
        }
        var str = String(input);
        var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
        for (var block, charCode, idx = 0, map = chars, output = ''; str.charAt(idx | 0) || (map = '=', idx % 1); output += map.charAt(63 & block >> 8 - idx % 1 * 8)) {
            charCode = str.charCodeAt(idx += 3 / 4);
            if (charCode > 0xFF) {
                throw "'btoa' failed: The string to be encoded contains characters outside of the Latin1 range.";
            }
            block = block << 8 | charCode;
        }
        return output;
    }
    function equalsAny(o, list) {
        for (var _i = 0, list_1 = list; _i < list_1.length; _i++) {
            var n = list_1[_i];
            if (o == n)
                return true;
        }
        return false;
    }
    function navigateToUrl(url, newWindow) {
        if (newWindow) {
            window.open(url, "_blank");
        }
        else {
            window.location.href = url;
        }
    }
    function convertLikeToRegex(sqlLike, notLike) {
        // Escape special regex characters
        // const escapedLike = sqlLike.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
        var escapedLike = sqlLike.replace(/[.*+?${}()|\\]/g, '\\$&');
        // Replace SQL wildcards with regex equivalents
        var regexLike = escapedLike.replace(/%/g, '.*').replace(/_/g, '.');
        // Add regex anchors to match the entire string
        var finalRegex = "^".concat(regexLike, "$");
        return new RegExp(finalRegex);
    }
    function arraySum(array, callback) {
        var sum = 0;
        // Using array.forEach here instead of array.reduce because reduce doesn't apply the function on the initial element of the array.
        array.forEach(function (element) {
            sum = sum + callback(element);
        });
        return sum;
    }
    function arrayAverage(array, callback) {
        var sum = arraySum(array, callback);
        return (sum / array.length);
    }
    function arrayMin(array, callback) {
        var min = undefined;
        array.forEach(function (element) {
            var result = callback(element);
            if (result < min || min === undefined) {
                min = result;
            }
        });
        return min;
    }
    function arrayMax(array, callback) {
        var max = undefined;
        array.forEach(function (element) {
            var result = callback(element);
            if (result > max || max === undefined) {
                max = result;
            }
        });
        return max;
    }
    function generateGuid(args) {
        if (!args || !args.guidLength) {
            args = { useStandardFormat: true };
        }
        var length = args.useStandardFormat ? 32 : args.guidLength;
        if (length < 8) {
            length = 8;
        }
        else if (length > 100) {
            length = 100;
        }
        var guid = 'x';
        guid = guid.padEnd(length, 'x');
        guid = guid.replace(/[xy]/g, function (c) {
            var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
        if (args.useStandardFormat) {
            guid = guid.slice(0, 8) + '-' + guid.slice(8, 12) + '-' + guid.slice(12, 16) + '-' + guid.slice(16, 20) + '-' + guid.slice(20, guid.length);
        }
        return guid;
    }

    var RestClient = /** @class */ (function () {
        function RestClient(e) {
            var _this = this;
            this.e = e;
            this.defaultPortNum = 0; // If 0 then use 80 for http and 443 for https
            this.cookies = [];
            this.processResponse = function (response) {
                if (response.cookies) {
                    var _loop_1 = function (key) {
                        var existingCookie = _this.cookies.find(function (c) { return c.name == key; });
                        if (existingCookie)
                            _this.cookies.remove(existingCookie);
                        _this.cookies.push({
                            name: key,
                            value: response.cookies[key]
                        });
                    };
                    for (var key in response.cookies) {
                        _loop_1(key);
                    }
                }
            };
        }
        RestClient.prototype.makeCall = function (params) {
            var _this = this;
            if (this.cookies.length) {
                if (!params.headers) {
                    params.headers = [];
                }
                params.headers.push({
                    name: "Cookie",
                    value: this.cookies.map(function (c) { return c.name + "=" + c.value; }).join("; ")
                });
            }
            if (!params.headers.find(function (h) { return h.name == "Connection"; })) {
                params.headers.push({
                    name: "Connection",
                    value: "keep-alive"
                });
            }
            params.headers.push({
                name: "User-Agent",
                value: "KBMax v3"
            });
            if (this.baseUrl) {
                params.url = this.baseUrl + params.url;
            }
            if (!params.headers.find(function (h) { return h.name == "Host"; })) {
                var l = getLocation(params.url);
                if (l) {
                    params.headers.push({
                        name: "Host",
                        value: l.hostname
                    });
                }
            }
            var contentType = params.headers.find(function (h) { return h.name == "Content-Type"; });
            if (!contentType) {
                contentType = {
                    name: "Content-Type",
                    value: "application/text"
                };
                params.headers.push(contentType);
            }
            if (typeof params.body != "string") {
                if (contentType.value == "application/json") {
                    params.body = JSON.stringify(params.body);
                }
                if (contentType.value == "application/x-www-form-urlencoded") {
                    params.body = toQueryString(params.body);
                }
            }
            params.headers.push({
                name: "Accept",
                value: contentType.value + ", text/plain, */*"
            });
            if (this.basicAuthUser && !params.authentication) {
                params.authentication = {
                    username: this.basicAuthUser,
                    password: this.basicAuthPass
                };
            }
            if (this.defaultPortNum && !params.port) {
                params.port = this.defaultPortNum;
            }
            return this.e.callRestService(params).then(function (restResponse) {
                _this.processResponse(restResponse);
                return restResponse;
            });
        };
        return RestClient;
    }());

    var SalesForceClient = /** @class */ (function () {
        function SalesForceClient(e) {
            this.e = e;
        }
        SalesForceClient.prototype.insert = function (model) {
            return this.e.callSfdc({
                operation: "insert",
                params: model
            }).then(function (resp) {
                if (resp.statusCode >= 200 && resp.statusCode < 400) {
                    return JSON.parse(resp.body).id;
                }
                throw resp.body;
            });
        };
        SalesForceClient.prototype.update = function (model) {
            return this.e.callSfdc({
                operation: "update",
                params: model
            }).then(function (resp) {
                if (resp.statusCode >= 200 && resp.statusCode < 400) {
                    return model.Id;
                }
                throw resp.body;
            });
        };
        SalesForceClient.prototype.delete = function (model) {
            return this.e.callSfdc({
                operation: "delete",
                params: model
            }).then(function (resp) {
                if (resp.statusCode >= 200 && resp.statusCode < 400) {
                    return model.Id;
                }
                throw resp.body;
            });
        };
        SalesForceClient.prototype.query = function (query) {
            return this.e.callSfdc({
                operation: "query",
                query: query
            }).then(function (resp) {
                if (resp.statusCode >= 200 && resp.statusCode < 400) {
                    return JSON.parse(resp.body).records;
                }
                throw resp.body;
            });
        };
        SalesForceClient.prototype.attachByTag = function (modelId, idQuote, idTag) {
            return this.e.attachFileToSfdc({
                source: 0,
                id: modelId,
                idQuote: idQuote,
                idTag: idTag
            });
        };
        SalesForceClient.prototype.attachMedia = function (modelId, mediaPath) {
            return this.e.attachFileToSfdc({
                source: 1,
                id: modelId,
                filePath: mediaPath
            });
        };
        SalesForceClient.prototype.attachQuoteProduct = function (modelId, idQuote, idTag, idQuoteProduct) {
            return this.e.attachFileToSfdc({
                source: 2,
                id: modelId,
                idQuote: idQuote,
                idTag: idTag,
                idQuoteProduct: idQuoteProduct
            });
        };
        return SalesForceClient;
    }());

    exports.ClientLogger = ClientLogger;
    exports.FluentIf = FluentIf;
    exports.KPromise = KPromise;
    exports.KineticClient = KineticClient;
    exports.Loop = Loop;
    exports.OracleCpqClient = OracleCpqClient;
    exports.RestClient = RestClient;
    exports.SalesForceClient = SalesForceClient;
    exports._dowhile = _dowhile;
    exports._for = _for;
    exports._if = _if;
    exports._while = _while;
    exports.arrayAverage = arrayAverage;
    exports.arrayMax = arrayMax;
    exports.arrayMin = arrayMin;
    exports.arraySum = arraySum;
    exports.btoa = btoa;
    exports.capitalize = capitalize;
    exports.clearTableCache = clearTableCache;
    exports.convertLikeToRegex = convertLikeToRegex;
    exports.dateAdd = dateAdd;
    exports.declareGlobalVariable = declareGlobalVariable;
    exports.equalsAny = equalsAny;
    exports.factorial = factorial;
    exports.formatDate = formatDate;
    exports.generateGuid = generateGuid;
    exports.getCharCodeAt = getCharCodeAt;
    exports.getGlobalVariable = getGlobalVariable;
    exports.getLocation = getLocation;
    exports.getNestedConfigurator = getNestedConfigurator;
    exports.getPrecision = getPrecision;
    exports.getQuoteProductFieldValue = getQuoteProductFieldValue;
    exports.getTables = getTables;
    exports.getUploadFieldUrl = getUploadFieldUrl;
    exports.indexOf = indexOf;
    exports.isNumeric = isNumeric;
    exports.logout = logout;
    exports.moveItemInArray = moveItemInArray;
    exports.navigateToUrl = navigateToUrl;
    exports.objToString = objToString;
    exports.padStringLeft = padStringLeft;
    exports.r = r;
    exports.roundNumber = roundNumber;
    exports.setGlobalVariable = setGlobalVariable;
    exports.setQuoteProductFieldValue = setQuoteProductFieldValue;
    exports.strMatch = strMatch;
    exports.strReplace = strReplace;
    exports.stringLength = stringLength;
    exports.stringSubstring = stringSubstring;
    exports.toLowerCase = toLowerCase;
    exports.toQueryString = toQueryString;
    exports.toTitleCase = toTitleCase;
    exports.toUpperCase = toUpperCase;
    exports.translateTemplateLiteral = translateTemplateLiteral;
    exports.trim = trim;

    return exports;

}({}, models, tools));


/*
    This file is a shim to make rule utilities available globally.  We concat it with the bundle
    after the bundle is already made.
*/
var handle = rules.handle;
var getTables = rules.getTables;
var r = rules.r;
var indexOf = rules.indexOf;
var stringLength = rules.stringLength;
var strReplace = rules.strReplace;
var getCharCodeAt = rules.getCharCodeAt;
var toUpperCase = rules.toUpperCase;
var toLowerCase = rules.toLowerCase;
var capitalize = rules.capitalize;
var toTitleCase = rules.toTitleCase;
var trim = rules.trim;
var objToString = rules.objToString;
var stringSubstring = rules.stringSubstring;
var isNumeric = rules.isNumeric;
var sleep = rules.sleep;
var getQuoteProductFieldValue = rules.getQuoteProductFieldValue;
var setQuoteProductFieldValue = rules.setQuoteProductFieldValue;
var factorial = rules.factorial;
var padStringLeft = rules.padStringLeft;
var dateAdd = rules.dateAdd;
var formatDate = rules.formatDate;
var getLocation = rules.getLocation;
var getNestedConfigurator = rules.getNestedConfigurator;
var toQueryString = rules.toQueryString;
var generateGuid = rules.generateGuid;

var _if = rules._if;
var _while = rules._while;
var _for = rules._for;
var Loop = rules.Loop;

var RestClient = rules.RestClient;
var OracleCpqClient = rules.OracleCpqClient;
var SalesForceClient = rules.SalesForceClient;
var KineticClient = rules.KineticClient;
//# sourceMappingURL=rules.js.map
